import substitutions from './substitutions.resource';

export default substitutions.reducer;
